<div class="order-history-table">
  <h2 class="order-history-table__title">{{ 'orderHistory.orderHistory' | cxTranslate }}</h2>
  <eb-generic-scroll [loading]="loading" (scrolled)="nextPage()">
    <ng-container *ngIf="dataStructure$ | async as structure">
      <cx-table
        [structure]="structure"
        [data]="salesDocuments"
        [i18nRoot]="'orderHistoryList'"
        class="order-history-table__table"
      >
      </cx-table>
    </ng-container>
    <div class="order-history-table__no-orders" *ngIf="showPlaceholder()">
      {{ 'orderHistoryList.noOrders' | cxTranslate }}
    </div>
  </eb-generic-scroll>
</div>
